import React, { useState, useEffect } from "react";
import { FaEdit ,FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import "./ServicesForm.css";
import Modal from "../components/modal/modal";
import CustomToastContainer from "../components/ToastMessage/ToastContainer";
import API_URLS from "../summaryapi/apiUrls";
import { RingLoader } from 'react-spinners'; // Import the spinner

function ServiceForm() {
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    service_name: "",
    service_img1: null,
    service_img2: null,
    description: "",
    service_price: "",
    category_id: "",
    isPopular: false,
    isActive: false,
  });
  const [imagePreviews, setImagePreviews] = useState([null, null]);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isCategorySelected, setIsCategorySelected] = useState(false);

  useEffect(() => {
    fetchServices();
    fetchCategories();
  }, []);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_URLS.getAllServices.url);
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setServices(data.data);
    } catch (error) {
      toast.error("Failed to load services.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_URLS.getAllServiceCategories.url);
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setCategories(data.data);
    } catch (error) {
      toast.error("Failed to load categories.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = ({ target: { name, value, type, checked } }) => {
    const newValue = type === "checkbox" ? checked : value;
    setFormData((prevData) => ({ ...prevData, [name]: newValue }));
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({ ...prevData, category_id: value }));
    setIsCategorySelected(value !== "");
  };

const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    
    if (file && allowedTypes.includes(file.type)) {
        setFormData((prevData) => ({
            ...prevData,
            [`service_img${index + 1}`]: file
        }));

        const newPreviews = [...imagePreviews];
        newPreviews[index] = URL.createObjectURL(file);
        setImagePreviews(newPreviews);
    } else {
        toast.error("Please select a valid image file (jpeg, png, gif).");
    }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!formData.service_name || !formData.category_id || !formData.service_price) {
      toast.error("Service Name, Category, and Price are required.");
      setLoading(false);
      return;
    }

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("category_id", formData.category_id);
    formDataToSubmit.append("service_name", formData.service_name);
    formDataToSubmit.append("description", formData.description);
    formDataToSubmit.append("service_price", formData.service_price);
    formDataToSubmit.append("isPopular", formData.isPopular ? 1 : 0);
    formDataToSubmit.append("isActive", formData.isActive ? 1 : 0);
    formDataToSubmit.append("service_img1", formData.service_img1);
    formDataToSubmit.append("service_img2", formData.service_img2);

    try {
      const url = isEditing ? API_URLS.updateService.url : API_URLS.createService.url;

      if (isEditing) {
        formDataToSubmit.append("service_id", services[editIndex].service_id);
      }

      const response = await fetch(url, {
        method: API_URLS.updateService.method,
        body: formDataToSubmit,
      });

      if (!response.ok) throw new Error(`Failed with status: ${response.status}`);
      await fetchServices();
      toast.success(`Service ${isEditing ? "updated" : "added"} successfully!`);
    } catch (error) {
      toast.error("Failed to save service.");
    } finally {
      setLoading(false);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormData({
      service_name: "",
      service_img1: null,
      service_img2: null,
      description: "",
      service_price: "",
      category_id: "",
      isPopular: false,
      isActive: false,
    });
    setImagePreviews([null, null]);
    setIsAddModalOpen(false);
    setIsEditing(false);
    setEditIndex(null);
    setIsCategorySelected(false);
  };

  const handleEdit = (index) => {
    setIsEditing(true);
    setEditIndex(index);
    const serviceToEdit = services[index];
    setFormData({
      service_name: serviceToEdit.service_name,
      description: serviceToEdit.description,
      service_price: serviceToEdit.service_price,
      category_id: serviceToEdit.category_id,
      isPopular: serviceToEdit.isPopular == 1,
      isActive: serviceToEdit.isActive == 1,
      service_img1: serviceToEdit.service_img1,
      service_img2: serviceToEdit.service_img2,
    });
    setImagePreviews([
      serviceToEdit.service_img1 ? `${API_URLS.getsevicesImages.url}${serviceToEdit.service_img1}` : null,
      serviceToEdit.service_img2 ? `${API_URLS.getsevicesImages.url}${serviceToEdit.service_img2}` : null,
    ]);
    setIsAddModalOpen(true);
    setIsCategorySelected(true);
  };


  return (
    <div>
      <div className="header">
        <h2 className="text-center" style={{color: '#8A2BE2'}}>Services</h2>
        <button onClick={() => setIsAddModalOpen(true)} className="add-service-button">
          <FaPlus /> Add Service
        </button>
      </div>

      {loading ? (
        <div className="loading-container">
          <RingLoader color="#3498db" loading={loading} size={50} />
          <h3 style={{color: '#8A2BE2'}}>Loading services...</h3>
        </div>
      ) : services.length === 0 ? (
        <p className="text-center" style={{color: '#8A2BE2'}}>No services added yet.</p>
      ) : ( <div>
        <div className="services-table-container" style={{ maxHeight: services.length > 8? '500px' : 'none' }}>
        <table className="services-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
  <thead>
    <tr>
      <th style={{ textAlign: 'right', backgroundColor: 'blueviolet', color: 'white'}}>Image 1</th>
      <th style={{ textAlign: 'right', backgroundColor: 'blueviolet', color: 'white'}}>Image 2</th>
      <th style={{ textAlign: 'center', backgroundColor: 'blueviolet', color: 'white'}}>Service Name</th>
      <th style={{ textAlign: 'center', backgroundColor: 'blueviolet', color: 'white'}}>Category</th>
      <th style={{ textAlign: 'center', backgroundColor: 'blueviolet', color: 'white'}}>Description</th>
      <th style={{ textAlign: 'center', backgroundColor: 'blueviolet', color: 'white'}}>Price</th>
      <th style={{ textAlign: 'center', backgroundColor: 'blueviolet', color: 'white'}}>Popular</th>
      <th style={{ textAlign: 'center', backgroundColor: 'blueviolet', color: 'white'}}>Active</th>
      <th style={{ textAlign: 'center', backgroundColor: 'blueviolet', color: 'white'}}>Actions</th>
    </tr>
  </thead>
  <tbody>
    {services.map((service, index) => {
      const category = categories.find(cat => cat.category_id == service.category_id);
      return (
        <tr key={service.service_id}>
          <td style={{ textAlign: 'center', padding: '8px' }}>
            {service.service_img1 && <img src={`${API_URLS.getsevicesImages.url}/${service.service_img1}`} alt={service.service_name} className="service-img image-preview" style={{ width: '60px', height: '60px', objectFit: 'cover' }} />}
          </td>
          <td style={{ textAlign: 'center', padding: '8px' }}>
            {service.service_img2 && <img src={`${API_URLS.getsevicesImages.url}/${service.service_img2}`} alt={service.service_name} className="service-img image-preview" style={{ width: '60px', height: '60px', objectFit: 'cover' }} />}
          </td>
          <td style={{ textAlign: 'center'}}><strong>{service.service_name}</strong></td>
          <td style={{ textAlign: 'center'}}>{category ? category.category_name : "N/A"}</td>
          <td style={{ textAlign: 'center'}}>{service.description}</td>
          <td style={{ textAlign: 'center'}}>{service.service_price}</td>
          <td style={{ textAlign: 'center', color: service.isPopular === '1' ? 'green' : 'red' }}>
  {service.isPopular === "1" ? "Yes" : "No"}
</td>

<td style={{ textAlign: 'center', color: service.isActive === '1' ? 'green' : 'red' }}>
  {service.isActive === '1' ? "Yes" : "No"}
</td>

          <td style={{ textAlign: 'center'}}>
            <button className="button-margin" onClick={() => handleEdit(index)} style={{ cursor: 'pointer', padding: '5px 10px' }}>
              <FaEdit />
            </button>
          </td>
        </tr>
      );
    })}
  </tbody>
</table>


      </div>
              <div className="services-footer">
              <p className="text-end">Total Services: {services.length}</p>
            </div>     </div>
      )}

<Modal isOpen={isAddModalOpen} onClose={resetForm} style={{ paddingTop: '20px' }}>
  <h2 className="modal-title" style={{ marginBottom: '10px' }}>{isEditing ? "Edit Service" : "Add Service"}</h2>
  <form onSubmit={handleSubmit} className="modal-form">
    <label>
      Category:
      <select
        name="category_id"
        value={formData.category_id}
        onChange={handleCategoryChange}
        required
        className="modal-select"
      >
        <option value="">Select a category</option>
        {categories.map((cat) => (
          <option key={cat.category_id} value={cat.category_id}>
            {cat.category_name}
          </option>
        ))}
      </select>
    </label>
    <label>
      Service Name:
      <input
        type="text"
        name="service_name"
        value={formData.service_name}
        onChange={handleChange}
        required
        className="modal-input"
        disabled={!isCategorySelected} // Disable if no category selected
      />
    </label>
    <label>
      Description:
      <textarea
        name="description"
        value={formData.description}
        onChange={handleChange}
        className="modal-textarea"
        disabled={!isCategorySelected} // Disable if no category selected
      />
    </label>
    <label>
      Price:
      <input
        type="number"
        name="service_price"
        value={formData.service_price}
        onChange={handleChange}
        required
        className="modal-input"
        disabled={!isCategorySelected} // Disable if no category selected
      />
    </label>

{/* Inside your Modal component */}
<div className="image-upload-group">
  <label>
    Service Image 1:
    <input
      type="file" style={{ maxWidth: "200px", height: "auto", borderRadius: "4px", marginTop: "8px" }}
      accept="image/*"
      onChange={(e) => handleImageChange(e, 0)}
      className="modal-file-input"
      disabled={!isCategorySelected} // Disable if no category selected
    />
    {imagePreviews[0] && (
      <img
        src={imagePreviews[0]} // Image preview for first image
        alt="Preview 1"
        className="image-preview"
        style={{ width: '100px', height: 'auto', objectFit: 'cover' }} // Preview 1 style
      />
    )}
  </label>
  <label>
    Service Image 2:
    <input style={{ maxWidth: "200px", height: "auto", borderRadius: "4px", marginTop: "8px" }}
      type="file"
      accept="image/*"
      onChange={(e) => handleImageChange(e, 1)}
      className="modal-file-input"
      disabled={!isCategorySelected} // Disable if no category selected
    />
    {imagePreviews[1] && (
      <img
        src={imagePreviews[1]} // Preview image for second image (updated path)
        alt="Preview 2"
        className="image-preview"
        style={{ width: '480px', height: '480px', objectFit: 'cover' }} // Second image with fixed size
      />
    )}
  </label>
</div>

<div className="toggle-container" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
  <label style={{ display: 'flex', alignItems: 'center' }}>
    Is Popular:
    <label style={{ position: 'relative', display: 'inline-block', width: '40px', height: '20px', marginLeft: '10px' }}>
      <input
        type="checkbox"
        name="isPopular"
        checked={formData.isPopular}
        onChange={handleChange}
        disabled={!isCategorySelected} // Disable if no category selected
        style={{
          opacity: 0, // Hide the default checkbox
          width: '0',
          height: '0',
          position: 'absolute',
        }}
      />
      <span
        style={{
          position: 'absolute',
          cursor: 'pointer',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: formData.isPopular ? '#4CAF50' : '#ccc', // Green for ON, Gray for OFF
          borderRadius: '20px', // Rounded corners
          transition: '0.4s', // Smooth transition for the background
        }}
      >
        <span
          style={{
            position: 'absolute',
            content: '',
            height: '16px', // Size of the toggle handle
            width: '16px', // Size of the toggle handle
            borderRadius: '50%',
            left: formData.isPopular ? '20px' : '2px', // Move handle to the right when ON
            bottom: '2px', // Position the handle inside the slider
            backgroundColor: 'white', // Handle color
            transition: '0.4s', // Smooth transition for handle movement
          }}
        ></span>
      </span>
    </label>
  </label>

  <label style={{ display: 'flex', alignItems: 'center' }}>
    Is Active:
    <label style={{ position: 'relative', display: 'inline-block', width: '40px', height: '20px', marginLeft: '10px' }}>
      <input
        type="checkbox"
        name="isActive"
        checked={formData.isActive}
        onChange={handleChange}
        disabled={!isCategorySelected} // Disable if no category selected
        style={{
          opacity: 0, // Hide the default checkbox
          width: '0',
          height: '0',
          position: 'absolute',
        }}
      />
      <span
        style={{
          position: 'absolute',
          cursor: 'pointer',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: formData.isActive ? '#4CAF50' : '#ccc', // Green for ON, Gray for OFF
          borderRadius: '20px', // Rounded corners
          transition: '0.4s', // Smooth transition for the background
        }}
      >
        <span
          style={{
            position: 'absolute',
            content: '',
            height: '16px', // Size of the toggle handle
            width: '16px', // Size of the toggle handle
            borderRadius: '50%',
            left: formData.isActive ? '20px' : '2px', // Move handle to the right when ON
            bottom: '2px', // Position the handle inside the slider
            backgroundColor: 'white', // Handle color
            transition: '0.4s', // Smooth transition for handle movement
          }}
        ></span>
      </span>
    </label>
  </label>
</div>




    <div className="button-container">
    <button 
  type="submit" 
  className="submit-button" 
  disabled={!isCategorySelected} 
  style={{ 
    fontSize: "1.2rem",  // Increase font size
    padding: "12px 20px", // Increase padding for a bigger button
    width: "auto",        // Set width to auto or you can specify a fixed width like "200px"
  }}
>
  {isEditing ? "Update" : "Add"}
</button>

    </div>
  </form>
</Modal>




      <CustomToastContainer />
    </div>
  );
}

export default ServiceForm;
